module.exports = __webpack_public_path__ + "../resources/images/newestTopLarge-211bd47381864f032cb2919fb909328f.svg";